export default "__VITE_ASSET__qhuMnzKb__"